// import config from "./config";
import { authHeader } from "../helpers/authHeader.js";
import Axios from "axios";
import { config } from "../helpers";

export const co2Service = {
  calculateCO2Footprint
};

function calculateCO2Footprint(customerIds, fromDate, toDate, bookingId) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    customerIds: customerIds,
    timeset: { from: fromDate, to: toDate },
    bookingId: bookingId
  };

  return Axios.post(
    `${config.apiUrlTools}/Tools/CalculateCO2Footprint`,
    body,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  if (response.status != "200") {
    const error = response.statusText;
    return Promise.reject(error);
  }
  return response.data;
}
